// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { unlock16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-unlock': IconUnlock;
    }
}

/**
 * The icon component for the 'unlock' icon
 */
export class IconUnlock extends Icon {
    public constructor() {
        super(unlock16X16);
    }
}

registerIcon('icon-unlock', IconUnlock);
export const iconUnlockTag = 'nimble-icon-unlock';
